import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {LabeledProcedureDropdown} from 'studies/typed/shared/LabeledProcedureDropdown';

interface ProcessDevelopmentStudyMetadataProps {
  procedureId: string | null;
  setProcedureId: (procedureId: string) => void;
  onRequestCloseModal: () => void;
  procedureType: ProcedureType;
}

/*
 * Inputs for any additional metadata (beyond standard study metadata such as name, folder, etc) specific to
 * creation of a Process Development study.
 */
export function ProcessDevelopmentStudyMetadata(props: ProcessDevelopmentStudyMetadataProps): JSX.Element {
  return (
    <LabeledProcedureDropdown
      procedureId={props.procedureId}
      setProcedureId={props.setProcedureId}
      onRequestCloseModal={props.onRequestCloseModal}
      procedureType={props.procedureType}
      requiredField={true}
      dropdownDisabled={false}
      // We need the latest possible procedure version id because that gets stamped into the new run
      procedureFetchPolicy="network-only"
    />
  );
}
